import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { brandActions } from '../../action/brandaction';

const AddBrand = ({ onBrandAdded }) => {
  const [brandData, setBrandData] = useState({
    brand_name: '',
    status: 'Active'
  });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBrandData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleStatusChange = (e) => {
    setBrandData(prev => ({
      ...prev,
      status: e.target.checked ? 'Active' : 'InActive'
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!brandData.brand_name.trim()) {
      alert('Brand name is required');
      return;
    }

    setLoading(true);
    try {
      const response = await dispatch(brandActions.createBrand(brandData));
      
      if (response.success) {
        // Reset form
        setBrandData({
          brand_name: '',
          status: 'Active'
        });
        
        // Close modal
        document.getElementById('closeAddBrandModal').click();
        
        // Refresh brand list
        if (onBrandAdded) {
          onBrandAdded();
        }
      }
    } catch (error) {
      console.error('Error adding brand:', error);
    } finally {
      setLoading(false);
    }
  };

  // Reset form when modal is closed
  useEffect(() => {
    const modal = document.getElementById('add-brand');
    const handleHidden = () => {
      setBrandData({
        brand_name: '',
        status: 'Active'
      });
    };
    
    modal.addEventListener('hidden.bs.modal', handleHidden);
    
    return () => {
      modal.removeEventListener('hidden.bs.modal', handleHidden);
    };
  }, []);

  return (
    <div className="modal fade" id="add-brand">
      <div className="modal-dialog modal-dialog-centered custom-modal-two">
        <div className="modal-content">
          <div className="modal-header border-0 custom-modal-header">
            <div className="page-title">
              <h4>Create Brand</h4>
            </div>
            <button
              type="button"
              className="close"
              data-bs-dismiss="modal"
              id="closeAddBrandModal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label>Brand Name *</label>
                <input
                  type="text"
                  className="form-control"
                  name="brand_name"
                  value={brandData.brand_name}
                  onChange={handleInputChange}
                  placeholder="Enter brand name"
                  required
                />
              </div>
              <div className="mb-0">
                <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                  <span className="status-label">Status</span>
                  <input
                    type="checkbox"
                    id="add_status"
                    className="check"
                    checked={brandData.status === 'Active'}
                    onChange={handleStatusChange}
                  />
                  <label htmlFor="add_status" className="checktoggle">
                    {brandData.status}
                  </label>
                </div>
              </div>
              <div className="modal-footer-btn mt-3">
                <button 
                  type="button" 
                  className="btn btn-cancel me-2" 
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="btn btn-submit" 
                  disabled={loading}
                >
                  {loading ? 'Creating...' : 'Create Brand'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

AddBrand.propTypes = {
  onBrandAdded: PropTypes.func.isRequired,
};

export default AddBrand;